import { render, staticRenderFns } from "./InactiveTrigram.vue?vue&type=template&id=2ed64376&scoped=true&"
import script from "./InactiveTrigram.vue?vue&type=script&lang=js&"
export * from "./InactiveTrigram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed64376",
  null
  
)

export default component.exports